<template>
    <div class="p-20px">
        <div class="flex items-center justify-between">
            <div class="w-35px h-35px" @click="goBack">
                <img src="@/assets/images/mine/left.webp" alt="" class="w-full h-full">
            </div>
            <div class="color-#fff text-14px">{{ t('account.aboutAccount') }}</div>
            <div class="w-35px h-35px"></div>
        </div>
        <div class="mt-30px">
            <div class="flex items-center justify-between pt-10px border-b pb-17px">
                <div class="color-#fff text-14px">
                    {{ t('account.id') }}
                </div>
                <div class="text-color text-12px flex items-center justify-center">
                    <div>
                        {{ userInfo.userId }}
                    </div>
                    <div class="w-16px h-16px flex items-center justify-center ml-5px cursor-pointer" @click="copyUserId">
                        <img src="@/assets/images/account/copy.webp" alt="" class="w-full h-full">
                    </div>
                </div>
            </div>
            <div class="flex items-center justify-between pt-30px pb-17px border-b">
                <div class="color-#fff text-14px">
                    {{ t('account.email') }}
                </div>
                <div class="text-color text-12px">
                    {{ userInfo.email }}
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { useRouter } from 'vue-router'
import { useUserStore } from '@/stores/user'
import { computed } from 'vue'
import { showToast } from '@/utils/toast'
import { useI18n } from 'vue-i18n'
const { t } = useI18n()
const userStore = useUserStore()
const userInfo = computed(() => userStore.userInfo)
const router = useRouter()
const goBack = () => {
    router.back()
}
const copyUserId = async () => {
    try {
        // 优先使用现代 Clipboard API
        if (navigator.clipboard && window.isSecureContext) {
            await navigator.clipboard.writeText(userInfo.value.userId)
            showToast(t('copy.copiedToClipboard'), { type: 'success' })
        } else {
            // 降级到传统方法
            const success = fallbackCopyText(userInfo.value.userId)
            if (success) {
                showToast(t('copy.copiedToClipboard'), { type: 'success' })
            } else {
                showToast(t('copy.copyFailed'), { type: 'error' })
            }
        }
    } catch (err) {
        // Clipboard API 失败，使用降级方案
        console.error('Clipboard API failed:', err)
        const success = fallbackCopyText(userInfo.value.userId)
        if (success) {
            showToast(t('copy.copiedToClipboard'), { type: 'success' })
        } else {
            showToast(t('copy.copyFailed'), { type: 'error' })
        }
    }
}

const fallbackCopyText = (text: string) => {
  // 创建临时 textarea
  const textArea = document.createElement('textarea');
  textArea.value = text;
  
  // 避免滚动到可视区域
  textArea.style.position = 'fixed';
  textArea.style.top = '-9999px';
  textArea.style.left = '-9999px';
  textArea.style.opacity = '0';
  
  document.body.appendChild(textArea);
  textArea.focus();
  textArea.select();
  
  try {
    // 执行复制命令
    const successful = document.execCommand('copy');
    document.body.removeChild(textArea);
    
    if (successful) {
      console.log('复制成功（传统方法）');
      return true;
    } else {
      console.error('复制失败');
      return false;
    }
  } catch (err) {
    console.error('复制错误:', err);
    document.body.removeChild(textArea);
    return false;
  }
}
</script>

<style scoped>
.text-color {
    color: rgba(255, 255, 255, 0.5);
}
.border-b {
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}
</style>